import React, { useEffect, useCallback, useState } from "react";
import { withFormik } from 'formik';
import * as Yup from "yup";
import queryString from 'query-string'
import { useTranslation } from 'react-i18next';
import Flags from "components/Icons/Flags"

// core components
import { Checkbox, Input } from "stories/forms";
import { Button, Typography, Link } from "stories/components"
import { Card, CardBody, CardHeader, Col, Container, Row } from "stories/layout"
import { useNotification } from "stories/components/Notification"
import { useAuthContext } from "contexts/AuthContext";
import { httpChangePassword, httpActivateInvatedUser } from "services/users";
import logo from "assets/images/logo_nav.png"
import { parseDragMeta } from "@fullcalendar/core";

import { logoutWhenTokenExp } from "services/logoutTokenExp";

// Import the new form component
import InvitationForm from "components/Forms/InvitationForm/InvitationForm";

const InvitationView = ({location, match, history}) => {
  const { t } = useTranslation();
  const { notify } = useNotification();
  const { getMyUser } = useAuthContext();
  
  let preSetValues = { }
  const [loading, setLoading] = useState(false);
  
  useEffect(() => {
    const parsed = queryString.parse(location.search);
    if (parsed?.token) {
      localStorage.removeItem("refreshToken");
      localStorage.setItem("accessToken", parsed?.token);
    }
  },[location])
  
  const parsed = queryString.parse(location.search);

  // Clean up URL parameters
  for (const [key, value] of Object.entries(parsed)) {
    if (key.startsWith("amp;")) {
      const newKey = key.replace("amp;", "");
      parsed[newKey] = value;
      delete parsed[key];
    }
  }

  let account_name = "";
  let business_identity_code = "";
  let email = "";

  if (parsed?.account_name) {
    account_name = parsed?.account_name;
  }
  if (parsed?.business_identity_code) {
    business_identity_code = parsed?.business_identity_code;
  } 
  if (parsed?.email) { 
    email = parsed?.email;
  }

  preSetValues = {
    ...defaultValues,
    email: email,
    company_name: account_name,
    business_identity_code: business_identity_code,
  };

  if (loading) {
    return (
      <Container fluid></Container>
    )
  }
  
  return (
    <>
      <Container className="mt-4 pb-5">
        <Row className="justify-content-center">
          <Col lg="6" md="7" className="">
            <InvitationForm 
              history={history} 
              t={t} 
              notify={notify} 
              preSetValues={preSetValues} 
              token={parsed?.token} 
            />
          </Col>
        </Row>
      </Container>
    </>
  )
}

const defaultValues = {
  id: null,
  first_name: "",
  last_name: "",
  new_password: "",
  check_password: "",
  company_name: "",
  business_identity_code: "asd",
  email: "",
}

export default InvitationView;
